import SuppliersApi from '@/services/shop/SuppliersApi'

export interface SupplierInterface {
  id: string
  name: string
  description: string
  address1: string
  address2: string
  postcode: string
  city: string
  state: string
  country: string
  phone: string
  email: string
  arena_id: bigint
  created_at: string
  updated_at: string
}

export class SupplierDTO implements SupplierInterface {
  id = ''
  name = ''
  description = ''
  address1 = ''
  address2 = ''
  postcode = ''
  city = ''
  state = ''
  country = ''
  phone = ''
  email = ''
  arena_id = 0n
  created_at = ''
  updated_at = ''
}

export default class Supplier extends SupplierDTO {
  static api = SuppliersApi

  constructor(DTO: SupplierDTO) {
    super()
    Object.assign(this, DTO)
  }
}
